import { PurseMovement } from "@/apis/transactions/transaction_detail.schema";
import { FormRowLayout } from "@/app/pages/my_account/components/form_layouts";
import { PurseHistory } from "@/schemas/payments.schema";
import { currencyFormatter } from "../../utilities";
import { Card, CardContent, CardHeader } from "../Card";
import { FormRowValue } from "../FormRow";
import { useTranslation } from 'react-i18next'


type Props = {
    purses: PurseMovement[] | PurseHistory[]
}

export function PurseMovementCard({ purses }: Props) {

  const { t } = useTranslation();

  if (purses.length === 0) {
    return null
  }

  return (
        <Card>
        <CardHeader>
          <h2 className="text-lg font-bold">{t('payment_details.purses')}</h2>
        </CardHeader>
        <CardContent>
          {
            purses.map((purse, index) => (
              <FormRowLayout key={index}>
                <div>
                {purse.name}
                <div className="font-normal">
                    {purse.student_name}
                </div>
                </div>
                <FormRowValue
                  text={`${currencyFormatter.format(purse.amount)}`}
                />
              </FormRowLayout>
            ))
          }
        </CardContent>
      </Card>
    )
}
